import { clsx } from 'clsx'
import type { Reaction } from '../../stores/chatStore'

interface ReactionBadgesProps {
  reactions: Reaction[]
  isUser?: boolean
  onReactionClick?: (emoji: string) => void
}

/**
 * Display emoji reaction badges below message (Telegram-style).
 * Shows each emoji with count, highlighted if user reacted.
 */
export default function ReactionBadges({ reactions, isUser = false, onReactionClick }: ReactionBadgesProps) {
  if (!reactions || reactions.length === 0) return null

  return (
    <div data-testid="reaction-badges" className="flex flex-wrap gap-1 mt-1">
      {reactions.map(({ emoji, count, reactedByMe }) => (
        <button
          key={emoji}
          data-testid={`reaction-badge-${emoji}`}
          onClick={() => onReactionClick?.(emoji)}
          className={clsx(
            'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-sm transition-colors',
            reactedByMe
              ? isUser
                ? 'bg-white/30 text-white'
                : 'bg-primary-100 text-primary-700'
              : isUser
                ? 'bg-white/10 text-white/80 hover:bg-white/20'
                : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
          )}
        >
          <span>{emoji}</span>
          {count > 1 && <span className="text-xs">{count}</span>}
        </button>
      ))}
    </div>
  )
}
